











import { Condition as ConditionEnum, Operator as OperatorEnum } from "@gaia-project/engine";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  components: {},
})
export default class Operator extends Vue {
  @Prop()
  condition!: ConditionEnum;

  @Prop()
  operator: OperatorEnum;

  get isTrigger() {
    return this.operator === OperatorEnum.Trigger;
  }
}
